import { Colors } from "themes/palette"

import { memo, useCallback } from "react"
import { IoMdAddCircleOutline } from "react-icons/io"
import { useNavigate } from "react-router-dom"
import styled from "styled-components"
import clsx from "clsx"
import Button from "components/EvtKit/button/Button"

const ButtonCustom = styled(Button)`
  width: 330px;
`

const IconButton = styled.div`
  width: 100%;
  display: flex;
  gap: 8px;
  flex-direction: row;
  justify-content: end;
`

interface CreateWebhoookButtonProps {
  title: string
}

const CreateWebhookButton = (props: CreateWebhoookButtonProps) => {
  const { title } = props
  const navigate = useNavigate()

  const handleClick = useCallback(() => {
    navigate("/webhooks/create")
  }, [])

  return (
    <IconButton>
      <ButtonCustom
        onClick={handleClick}
        iconLeft={<IoMdAddCircleOutline size={24} color={Colors.white} />}
        label={title}
        className={clsx("background-gradient")}
      />
    </IconButton>
  )
}

export default memo(CreateWebhookButton)
